import { render, staticRenderFns } from "./OfferJoins.vue?vue&type=template&id=c8fe18c4&scoped=true&"
import script from "./OfferJoins.vue?vue&type=script&lang=js&"
export * from "./OfferJoins.vue?vue&type=script&lang=js&"
import style0 from "./OfferJoins.vue?vue&type=style&index=0&id=c8fe18c4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fe18c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
